import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StockApiService} from '../../services/stock-api.service';
import {BrandService} from '../../services/brand.service';
import {EmptyModalComponent} from '../../modals/empty-modal/empty-modal.component';
import {AdobeService} from '../../services/adobe.service';
import {ErrorHandler} from '../../tools/error-handler';
import {BlueKaiService} from '../../services/blue-kai.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
})
export class FormComponent implements OnInit {

  @Input() cta: string;
  @Input() brand_slug: string = null;
  @Input() dealer: string = null;
  @Input() model_id: string = null;
  @Input() vin: string = null;
  @Input() adobeThankyouPageData: any = null;
  @Output() error: EventEmitter<any> = new EventEmitter();

  sendEvent: EventEmitter<any> = new EventEmitter();
  changeZipCode: EventEmitter<any> = new EventEmitter();
  form = null;
  fields = [];
  loading = true;
  status = 0; // -1 when error & 1 when success
  cannotLoadForm = false;
  errorForm = false;
  private fillingOutStarted = false;

  formValues = {};
  errors = {};

  constructor(
      private stockApiService: StockApiService,
      private adobeService: AdobeService,
      private blueKaiService: BlueKaiService,
  ) {
  }

  isHiddenField(field: any): boolean {
    if (field.type === 'hidden') {
      return true;
    }

    if (field.name === 'dealer_sincom' && this.dealer !== null) {
      return true;
    }

    if (field.name === 'model_id') {
      return true;
    }

    if (this.vin !== null && this.vin.length > 0) {
      this.formValues['vin'] = this.vin;
    }

    if (field.name === 'brand_id') {
      return true;
    }

    if (field.name === 'g-recaptcha-response') {
      return true;
    }

    // FCAGENERAL-172 Wyłączenie preferowanej metody kontaktu
    if (field.name === 'communication_channel') {
      return true;
    }

    return false;
  }

  ngOnInit() {
    this.stockApiService.getLeadForm(this.cta, this.brand_slug).then(value => {
      this.fields = Object.keys(value.fields);
      for (const key of this.fields) {
        this.errors[key] = [];
        this.formValues[key] = value.fields[key].value;
      }

      for (const key of value.agreements) {
        this.errors[key.inputs[0].name] = [];
        this.formValues[key.inputs[0].name] = null;

      }

      this.form = value;
      this.loading = false;

      if (this.dealer !== null) {
        this.formValues['dealer_sincom'] = this.dealer;
      }

      if (this.model_id !== null) {
        this.formValues['model_id'] = this.model_id;
      }

      this.formValues['brand_id'] = this.brand_slug === 'fiat-professional' ? '77' : BrandService.getCurrentBrand().code;
    }).catch(reason => {
      this.cannotLoadForm = true;
      this.error.emit('cannot load form');
      ErrorHandler.handle(reason);
    });
  }

  send() {
    if (this.isFormValid()) {
      this.loading = true;
      this.stockApiService.sendLead(this.cta, this.formValues, this.brand_slug).then(value => {
        this.loading = false;

        if (value.status === 1) {
          this.status = 1;
          let type = 'not defined';

          if (this.form.cta && this.form.cta[0]) {
            if (this.form.cta[0] === 'RP') {
              type = 'request-form';
            } else if (this.form.cta[0] === 'NL') {
              type = 'newsletter';
            } else {
              type = this.form.cta[0];
            }
          }

          if (value['0'] && value['0'].lead_id) {
            this.adobeService.thankYouPage(this.adobeThankyouPageData, value['0'].lead_id);
            this.blueKaiService.thankYouPage(type);
          } else {
            this.adobeService.thankYouPage(this.adobeThankyouPageData, '');
            this.blueKaiService.thankYouPage(type);
          }

        } else {
          let validErrors = false;
          if (value.errors && Object.keys(value.errors).length > 0) {
            this.updateCsrfProtectField();
            this.sendEvent.emit((new Date()).getTime());

            for (const key of Object.keys(value.errors)) {
              this.errors[key] = value.errors[key];
            }
            validErrors = true;
          }

          if (value.absent_fields && value.absent_fields.length > 0) {
            for (const field of value.absent_fields) {
              if (typeof this.errors[field] === typeof []) {
                this.errors[field].unshift('Pole wymagane');
              } else {
                this.errors[field] = ['Pole wymagane'];
              }
            }
            validErrors = true;
          }

          if (!validErrors) {
            this.status = -1;
          }

          if (value.message !== undefined) {
            this.errorForm = true;
          }
        }
      }).catch(reason => {
        this.loading = false;
        ErrorHandler.handle(reason);
      });
    } else {
      this.loading = false;
      this.sendEvent.emit((new Date()).getTime());
    }
  }

  isFormValid(): boolean {
    this.validateFields();
    this.validateAgreements();

    for (const key of Object.keys(this.errors)) {
      if (this.errors[key].length > 0) {
        return false;
      }
    }

    return true;
  }

  validateFields() {

    for (const field of Object.keys(this.form.fields)) {
      this.errors[field] = [];
      if (!this.isHiddenField(this.form.fields[field])) {
        const name = this.form.fields[field].name;

        if (name === 'phone' && this.formValues['communication_channel'] === 'M') {
          return;
        }

        for (const rule of this.form.fields[name].rules) {
          if (rule.regex !== null) {
            const regEx = new RegExp(rule.regex.substr(1, rule.regex.length - 2));

            if (this.formValues[name] === null || !regEx.test(this.formValues[name])) {
              this.errors[name].push(rule.message);
              break;
            }
          }
        }
      }
    }

    if (this.errors['repeat_email'].length === 0 && this.formValues['email'] !== this.formValues['repeat_email']) {
      this.errors['repeat_email'].push('Adresy e-mail nie są takie same');
    }
  }

  validateAgreements() {
    for (const agreement of this.form.agreements) {
      if (agreement.required === true) {
        let isEmpty = true;
        for (const input of agreement.inputs) {
          if (this.formValues[input.name] === input.value) {
            isEmpty = false;
          }
        }

        if (isEmpty) {
           this.errors[agreement.inputs[0].name] = ['Pole wymagane'];
        } else {
          this.errors[agreement.inputs[0].name] = [];
        }
      }
    }
  }

  change($event) {
    if ($event.value === 'undefined' || $event.value === 'null') {
      this.formValues[$event.name] = null;
    } else {
      this.formValues[$event.name] = $event.value;
    }

    if ($event.name === 'zipcode') {
      this.changeZipCode.emit(this.formValues[$event.name]);
    } else if ($event.name === 'communication_channel' && $event.value === 'M') {
      this.errors['phone'] = [];
    }

    this.errors[$event.name] = [];
  }

  openPolicyNotes() {
    EmptyModalComponent.openModal(this.form.disclaimer.information.content['privacy-notes'], true);
  }

  clickFormElement() {
    if (!this.fillingOutStarted) {
      this.fillingOutStarted = true;
      let type = 'not defined';

      if (this.form.cta && this.form.cta[0]) {
        if (this.form.cta[0] === 'RP') {
          type = 'request-form';
        } else if (this.form.cta[0] === 'NL') {
          type = 'newsletter';
        } else {
          type = this.form.cta[0];
        }
      }
      this.blueKaiService.formFillingOutStart(type);
    }
  }

  updateCsrfProtectField () {
    let fieldName = '';
    if (this.form.cta[0] === 'RP') {
      fieldName = 'csrf_protect_field_d3d332d22ds32d2d2d092m_rp';
    } else if (this.form.cta[0] === 'NL') {
      fieldName = 'csrf_protect_field_d3d332d22ds32d2d2d092m_nl';
    }

    this.stockApiService.getLeadForm(this.cta, this.brand_slug).then(value => {
      if (value.fields[fieldName] !== undefined) {
        this.formValues[fieldName] = value.fields[fieldName].value;
      }
      this.loading = false;
    }).catch(reason => {
      this.cannotLoadForm = true;
      this.error.emit('cannot load form');
      ErrorHandler.handle(reason);
    });
  }
}
